<template>
  <div class="w-75 m-auto">
    <el-header class="h-auto my-4">
      <h3 class="text-uppercase font-weight-bold">Rechercher une raison sociale</h3>
    </el-header>
    <section>
      <el-input
          v-model="searchPrompt"
          size="large"
          placeholder="Rechercher une Raison Sociale (Ex: Koesio AURA) | Siren (Ex: 381228386) | Siret (Ex: 38122838600102)"
          :prefix-icon="Search"
      />
      <div class="d-flex justify-content-end mt-3">
        <el-switch
            v-if="this.searchResult && this.searchResult.length !== 0 && !isSiretSearch"
            v-model="searchActiveCompany"
            active-text="Masquer les SIRET inactifs"
            @change="handleSwitchChange"
        />
      </div>
    </section>
    <section>
      <div class="row">
        <template v-if="searchLoader">
          <div class="text-center m-auto mt-5 loader"></div>
        </template>
        <template v-else-if="!searchResult">
          <section class="col-6 m-auto text-center p-5">
            <LottieAnimation
                :animation-data="require('@/assets/tier.json')"
                background="transparent"
                class="m-auto"
                :speed=1
                style="width: 80%; height: 80%"
                loop
                autoplay
            ></LottieAnimation>
          </section>
        </template>
        <template v-else-if="searchResult && !searchResult.length">
          <p class="col-6 m-auto text-center p-5">Aucun résultat</p>
        </template>

        <template v-else-if="isSiretSearch && searchResult.length">
          <div class="site col-lg-10 m-auto">
            <SiteButton
                v-for="site in searchResult"
                :key="site.registrationId"
                :site="site"
                additional-classes="mt-3"
                @click="createTier"
            />
          </div>
        </template>

        <el-collapse v-else accordion class="mx-auto my-3 col-lg-10" @change="handleCollapseChange" ref="companyCollapse">
          <el-collapse-item :name="index" :key="result" v-for="(result, index) in searchResult">
            <template #title>
              <div class="d-flex align-items-center">
                <div class="d-flex align-items-center">
                  <img
                      class="mr-3"
                      style="width: 30px; height: 30px;"
                      src="/img/flat-building.ecf38a3b.png"
                      alt="Building"
                  >
                  <div class="d-flex align-items-center">
                    <span>{{ result.names?.[0]?.name }}</span>
                    <span class="ml-1"> - {{ result.registrationId }}</span>
                  </div>
                </div>
                <el-tooltip content="Nombre de site ouvert" placement="right">
                  <el-tag
                      class="ml-3"
                      round
                      :type="result.sites?.activeCount > 0 ? 'primary' : 'warning'"
                  >
                    {{ result.sites?.activeCount }}
                  </el-tag>
                </el-tooltip>
              </div>
            </template>
            <div class="text-center">
              <div v-if="loadingSite" class="loader"></div>
              <div v-else>
                <div v-if="!searchSite.length">
                  <p>Aucun site trouvé</p>
                </div>
                <div v-else class="site">
                  <SiteButton
                      v-for="site in searchSite"
                      :key="site.registrationId"
                      :site="site"
                      additional-classes="mx-auto"
                      @click="createTier"
                  />
                </div>
              </div>
            </div>
            <div>
              <el-pagination
                  v-if="totalItems > pageSize"
                  v-model:current-page="currentPage"
                  @current-change="handlePageChange"
                  @click.stop
                  :page-size="pageSize"
                  :total="totalItems"
                  layout="prev, pager, next"
                  background
                  class="justify-content-center mt-4"
              />
            </div>
          </el-collapse-item>
        </el-collapse>
      </div>
      <el-pagination
          v-if="paginationTotal > maxElem && !isSiretSearch"
          background
          layout="prev, pager, next, sizes"
          :page-sizes="[5, 10, 20, 50, 100]"
          v-model:page-size="maxElem"
          :current-page="currentCompanyPage"
          @current-change="handleChange"
          :total="paginationTotal"
          class="my-4 justify-content-center"
      />
    </section>
    <el-dialog
        v-model="dialogVisible"
        title="Attention"
        width="30%"
    >
      <span>Vous ne pouvez pas créer de simulation sur une raison sociale inactif</span>
      <template #footer>
        <div class="dialog-footer">
          <el-button type="primary" @click="dialogVisible = false">
            Fermer
          </el-button>
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<script>

import _, {} from "lodash";
import OrganisationServices from "@/services/organisation.services";
import {Search} from "@element-plus/icons";
import fundingService from "@/services/funding.service";
import tierService from "@/services/tier.service";
import customerService from "@/services/customer.service";
import SiteButton from "@/components/SiteButton.vue";

export default {
  name: 'Tier',
  components: {
    SiteButton
  },
  data() {
    return {
      searchPrompt: null,
      searchResult: null,
      searchSite: [],
      searchLoader: false,
      loadingSite: false,
      currentCompany: null,
      dialogVisible: false,
      currentPage: 1,
      pageSize: 30,
      totalItems: 0,
      isSiretSearch: false,
      searchActiveCompany: true,
      pagination: null,
      paginationTotal: 0,
      maxElem: 10,
      currentCompanyPage: 1
    };
  },
  watch: {
    searchPrompt: _.debounce(function () {
      this.globalSearch();
    }, 500),
    maxElem(newSize, oldSize) {
      if (oldSize && newSize !== oldSize) {
        this.handleMaxElemChange(newSize, oldSize);
      }
    }
  },
  computed: {
    Search() {
      return Search
    },
    getStatus() {
      return this.searchActiveCompany ? 'AC' : '';
    }
  },
  methods: {
    createTier(site) {
      if (site.status !== 'AC') {
        this.dialogVisible = true;
        return
      }
      this.loadingSite = true
      tierService.createThirdpartyBySiret(site.registrationId).then((response) => {
        this.$router.push({name: 'funding', params: {id: response.data}})
      }).catch((error) => {
        if (error.response.status === 409) {
          customerService.getCustomerBysiret(site.registrationId).then((response) => {
            this.$router.push({name: 'funding', params: {id: response.data[0].id}})
          })
        }
      }).finally(() => {
        this.loadingSite = false;
      })
    },
    async globalSearch() {
      this.isSiretSearch = false;
      this.currentCompanyPage = 1;

      if (this.searchPrompt === '') {
        this.searchResult = null;
        this.pagination = null;
        this.paginationTotal = 0;
        return;
      }
      if (this.searchPrompt?.length < 3) {
        return;
      }

      this.searchLoader = true;

      let query = this.getQueryFromSearchInput(this.searchPrompt);
      let cleanQuery = query.registrationId ? query.registrationId.replace(/\s/g, '') : '';

      if (cleanQuery.length === 14) {
        this.isSiretSearch = true;
        await this.fetchSite();
      } else {
        await this.fetchCompany(1, this.getStatus);
      }

      this.searchLoader = false;

    },
    getQueryFromSearchInput(search) {
      const registrationIdRegExp = new RegExp(
          "(\\d{14}|\\d{3}[ ]\\d{3}[ ]\\d{3}[ ]\\d{5}|\\d{9}[ ]\\d{5}|\\d{9}|\\d{3}[ ]\\d{3}[ ]\\d{3})"
      );
      let registrationId = registrationIdRegExp.exec(search);
      if (registrationId) {
        return {'registrationId': registrationId[0]}

      }
      return {'name': search}
    },
    async fetchSite() {
      let query = this.getQueryFromSearchInput(this.searchPrompt);
      OrganisationServices.getSiteBySiret(query.registrationId).then((response) => {
        this.searchResult = response?.data?.items || [response?.data]
        this.searchLoader = false
      })
    },
    async fetchCompany(page = 1, status = '') {
      let query = this.getQueryFromSearchInput(this.searchPrompt);

      try {
        const response = await OrganisationServices.searchCompanies(query, page, this.maxElem, status);

        this.searchResult = response.data.data;
        this.pagination = response.data.meta;
        this.paginationTotal = response.data.meta?.totalCount || 0;
        this.currentCompanyPage = page;
      } finally {
        this.searchLoader = false;
      }
    },
    async fetchSiteByCompany(companyId) {
      this.loadingSite = true;
      await OrganisationServices.getSiteByCompany(companyId, this.currentPage, this.pageSize, this.getStatus).then((response) => {
        this.totalItems = response.data.meta?.totalCount || 0;
        this.searchSite = response.data.data;
        this.currentCompany = companyId;
        this.searchSite.map(async (site) => {
          await fundingService.getSimulationsBySiret(site.registrationId).then((response) => {
            site.leaseboardSimulation = response.data.pagination.item_count;
          })
          return site;
        })
        this.loadingSite = false;
      })
    },
    handleSwitchChange() {
      // Le filtre porte aussi sur la liste des raisons sociales : elle est
      // refiltrée, donc les index du collapse ne sont plus valides.
      this.$refs.companyCollapse && (this.$refs.companyCollapse.activeNames = []);
      this.currentCompany = null;
      this.currentPage = 1;
      this.currentCompanyPage = 1;

      this.fetchCompany(1, this.getStatus);
    },
    handlePageChange(page) {
      this.currentPage = page;
      this.fetchSiteByCompany(this.currentCompany);
    },
    handleCollapseChange(activeIndex) {
      if (activeIndex !== null && activeIndex !== undefined) {
        const result = this.searchResult[activeIndex];
        if (result) {
          this.currentPage = 1;
          this.fetchSiteByCompany(result.registrationId);
        }
      }
    },
    handleChange(page) {
      this.$refs.companyCollapse && (this.$refs.companyCollapse.activeNames = []);

      this.currentCompanyPage = page;
      this.fetchCompany(page, this.getStatus);
    },
    handleMaxElemChange(newSize, oldSize) {
      const currentFirstItemIndex = (this.currentCompanyPage - 1) * oldSize;

      this.currentCompanyPage = Math.max(1, Math.floor(currentFirstItemIndex / newSize) + 1);

      const maxPage = Math.ceil(this.paginationTotal / newSize);
      if (this.currentCompanyPage > maxPage) {
        this.currentCompanyPage = maxPage;
      }

      this.fetchCompany(this.currentCompanyPage, this.getStatus);
    }
  },
};
</script>

<style scoped>

.loader {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  display: inline-block;
  position: relative;
  border: 3px solid;
  border-color: #FFF #FFF transparent transparent;
  box-sizing: border-box;
  animation: rotation 1s linear infinite;
}

.loader::after,
.loader::before {
  content: '';
  box-sizing: border-box;
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  margin: auto;
  border: 3px solid;
  border-color: transparent transparent #FF3D00 #FF3D00;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  box-sizing: border-box;
  animation: rotationBack 0.5s linear infinite;
  transform-origin: center center;
}

.loader::before {
  width: 32px;
  height: 32px;
  border-color: #FFF #FFF transparent transparent;
  animation: rotation 1.5s linear infinite;
}

@keyframes rotation {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

@keyframes rotationBack {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(-360deg);
  }
}

</style>